import { SxProps } from '@mui/material';

export const deliveryLocatorContentContainerSX: SxProps = {
	px: '20px',
	py: '15px',
	gap: '10px',
};

export const deliveryLocatorIntroTextSX: SxProps = {
	color: 'grey.500',
};

export const deliveryLocatorContentDividerSX: SxProps = {
	my: '10px',
};

export const blockedZipCodeWarningSX: SxProps = {
	color: 'grey.500',
	backgroundColor: 'alert.light',
	borderRadius: '3px',
	padding: '10px',
	textAlign: 'left',
};
